/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "včeraj",
        "-2": "predvčerajšnjim",
        "0": "danes",
        "1": "jutri",
        "2": "pojutrišnjem",
        "future": {
          "few": "čez {0} dni",
          "one": "čez {0} dan",
          "other": "čez {0} dni",
          "two": "čez {0} dneva"
        },
        "past": {
          "few": "pred {0} dnevi",
          "one": "pred {0} dnevom",
          "other": "pred {0} dnevi",
          "two": "pred {0} dnevoma"
        }
      },
      "day-narrow": {
        "-1": "včeraj",
        "-2": "predvčerajšnjim",
        "0": "danes",
        "1": "jutri",
        "2": "pojutrišnjem",
        "future": {
          "few": "čez {0} dni",
          "one": "čez {0} dan",
          "other": "čez {0} dni",
          "two": "čez {0} dneva"
        },
        "past": {
          "few": "pred {0} dnevi",
          "one": "pred {0} dnevom",
          "other": "pred {0} dnevi",
          "two": "pred {0} dnevoma"
        }
      },
      "day-short": {
        "-1": "včeraj",
        "-2": "predvčerajšnjim",
        "0": "danes",
        "1": "jutri",
        "2": "pojutrišnjem",
        "future": {
          "few": "čez {0} dni",
          "one": "čez {0} dan",
          "other": "čez {0} dni",
          "two": "čez {0} dneva"
        },
        "past": {
          "few": "pred {0} dnevi",
          "one": "pred {0} dnevom",
          "other": "pred {0} dnevi",
          "two": "pred {0} dnevoma"
        }
      },
      "hour": {
        "0": "v tej uri",
        "future": {
          "few": "čez {0} ure",
          "one": "čez {0} uro",
          "other": "čez {0} ur",
          "two": "čez {0} uri"
        },
        "past": {
          "few": "pred {0} urami",
          "one": "pred {0} uro",
          "other": "pred {0} urami",
          "two": "pred {0} urama"
        }
      },
      "hour-narrow": {
        "0": "v tej uri",
        "future": {
          "few": "čez {0} h",
          "one": "čez {0} h",
          "other": "čez {0} h",
          "two": "čez {0} h"
        },
        "past": {
          "few": "pred {0} h",
          "one": "pred {0} h",
          "other": "pred {0} h",
          "two": "pred {0} h"
        }
      },
      "hour-short": {
        "0": "v tej uri",
        "future": {
          "few": "čez {0} ure",
          "one": "čez {0} uro",
          "other": "čez {0} ur",
          "two": "čez {0} uri"
        },
        "past": {
          "few": "pred {0} urami",
          "one": "pred {0} uro",
          "other": "pred {0} urami",
          "two": "pred {0} urama"
        }
      },
      "minute": {
        "0": "to minuto",
        "future": {
          "few": "čez {0} minute",
          "one": "čez {0} minuto",
          "other": "čez {0} minut",
          "two": "čez {0} minuti"
        },
        "past": {
          "few": "pred {0} minutami",
          "one": "pred {0} minuto",
          "other": "pred {0} minutami",
          "two": "pred {0} minutama"
        }
      },
      "minute-narrow": {
        "0": "to minuto",
        "future": {
          "few": "čez {0} min",
          "one": "čez {0} min",
          "other": "čez {0} min",
          "two": "čez {0} min"
        },
        "past": {
          "few": "pred {0} min",
          "one": "pred {0} min",
          "other": "pred {0} min",
          "two": "pred {0} min"
        }
      },
      "minute-short": {
        "0": "to minuto",
        "future": {
          "few": "čez {0} min.",
          "one": "čez {0} min.",
          "other": "čez {0} min.",
          "two": "čez {0} min."
        },
        "past": {
          "few": "pred {0} min.",
          "one": "pred {0} min.",
          "other": "pred {0} min.",
          "two": "pred {0} min."
        }
      },
      "month": {
        "-1": "prejšnji mesec",
        "0": "ta mesec",
        "1": "naslednji mesec",
        "future": {
          "few": "čez {0} mesece",
          "one": "čez {0} mesec",
          "other": "čez {0} mesecev",
          "two": "čez {0} meseca"
        },
        "past": {
          "few": "pred {0} meseci",
          "one": "pred {0} mesecem",
          "other": "pred {0} meseci",
          "two": "pred {0} mesecema"
        }
      },
      "month-narrow": {
        "-1": "prejšnji mesec",
        "0": "ta mesec",
        "1": "naslednji mesec",
        "future": {
          "few": "čez {0} mes.",
          "one": "čez {0} mes.",
          "other": "čez {0} mes.",
          "two": "čez {0} mes."
        },
        "past": {
          "few": "pred {0} mes.",
          "one": "pred {0} mes.",
          "other": "pred {0} mes.",
          "two": "pred {0} mes."
        }
      },
      "month-short": {
        "-1": "prejšnji mesec",
        "0": "ta mesec",
        "1": "naslednji mesec",
        "future": {
          "few": "čez {0} mes.",
          "one": "čez {0} mes.",
          "other": "čez {0} mes.",
          "two": "čez {0} mes."
        },
        "past": {
          "few": "pred {0} mes.",
          "one": "pred {0} mes.",
          "other": "pred {0} mes.",
          "two": "pred {0} mes."
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "zadnje četrtletje",
        "0": "to četrtletje",
        "1": "naslednje četrtletje",
        "future": {
          "few": "čez {0} četrtletja",
          "one": "čez {0} četrtletje",
          "other": "čez {0} četrtletij",
          "two": "čez {0} četrtletji"
        },
        "past": {
          "few": "pred {0} četrtletji",
          "one": "pred {0} četrtletjem",
          "other": "pred {0} četrtletji",
          "two": "pred {0} četrtletjema"
        }
      },
      "quarter-narrow": {
        "-1": "zadnje četrtletje",
        "0": "to četrtletje",
        "1": "naslednje četrtletje",
        "future": {
          "few": "čez {0} četr.",
          "one": "čez {0} četr.",
          "other": "čez {0} četr.",
          "two": "čez {0} četr."
        },
        "past": {
          "few": "pred {0} četr.",
          "one": "pred {0} četr.",
          "other": "pred {0} četr.",
          "two": "pred {0} četr."
        }
      },
      "quarter-short": {
        "-1": "zadnje četrtletje",
        "0": "to četrtletje",
        "1": "naslednje četrtletje",
        "future": {
          "few": "čez {0} četrtl.",
          "one": "čez {0} četrtl.",
          "other": "čez {0} četrtl.",
          "two": "čez {0} četrtl."
        },
        "past": {
          "few": "pred {0} četrtl.",
          "one": "pred {0} četrtl.",
          "other": "pred {0} četrtl.",
          "two": "pred {0} četrtl."
        }
      },
      "second": {
        "0": "zdaj",
        "future": {
          "few": "čez {0} sekunde",
          "one": "čez {0} sekundo",
          "other": "čez {0} sekund",
          "two": "čez {0} sekundi"
        },
        "past": {
          "few": "pred {0} sekundami",
          "one": "pred {0} sekundo",
          "other": "pred {0} sekundami",
          "two": "pred {0} sekundama"
        }
      },
      "second-narrow": {
        "0": "zdaj",
        "future": {
          "few": "čez {0} s",
          "one": "čez {0} s",
          "other": "čez {0} s",
          "two": "čez {0} s"
        },
        "past": {
          "few": "pred {0} s",
          "one": "pred {0} s",
          "other": "pred {0} s",
          "two": "pred {0} s"
        }
      },
      "second-short": {
        "0": "zdaj",
        "future": {
          "few": "čez {0} s",
          "one": "čez {0} s",
          "other": "čez {0} s",
          "two": "čez {0} s"
        },
        "past": {
          "few": "pred {0} s",
          "one": "pred {0} s",
          "other": "pred {0} s",
          "two": "pred {0} s"
        }
      },
      "week": {
        "-1": "prejšnji teden",
        "0": "ta teden",
        "1": "naslednji teden",
        "future": {
          "few": "čez {0} tedne",
          "one": "čez {0} teden",
          "other": "čez {0} tednov",
          "two": "čez {0} tedna"
        },
        "past": {
          "few": "pred {0} tedni",
          "one": "pred {0} tednom",
          "other": "pred {0} tedni",
          "two": "pred {0} tednoma"
        }
      },
      "week-narrow": {
        "-1": "prejšnji teden",
        "0": "ta teden",
        "1": "naslednji teden",
        "future": {
          "few": "čez {0} ted.",
          "one": "čez {0} ted.",
          "other": "čez {0} ted.",
          "two": "čez {0} ted."
        },
        "past": {
          "few": "pred {0} ted.",
          "one": "pred {0} ted.",
          "other": "pred {0} ted.",
          "two": "pred {0} ted."
        }
      },
      "week-short": {
        "-1": "prejšnji teden",
        "0": "ta teden",
        "1": "naslednji teden",
        "future": {
          "few": "čez {0} ted.",
          "one": "čez {0} ted.",
          "other": "čez {0} ted.",
          "two": "čez {0} ted."
        },
        "past": {
          "few": "pred {0} ted.",
          "one": "pred {0} ted.",
          "other": "pred {0} ted.",
          "two": "pred {0} ted."
        }
      },
      "year": {
        "-1": "lani",
        "0": "letos",
        "1": "naslednje leto",
        "future": {
          "few": "čez {0} leta",
          "one": "čez {0} leto",
          "other": "čez {0} let",
          "two": "čez {0} leti"
        },
        "past": {
          "few": "pred {0} leti",
          "one": "pred {0} letom",
          "other": "pred {0} leti",
          "two": "pred {0} letoma"
        }
      },
      "year-narrow": {
        "-1": "lani",
        "0": "letos",
        "1": "naslednje leto",
        "future": {
          "few": "čez {0} leta",
          "one": "čez {0} leto",
          "other": "čez {0} let",
          "two": "čez {0} leti"
        },
        "past": {
          "few": "pred {0} leti",
          "one": "pred {0} letom",
          "other": "pred {0} leti",
          "two": "pred {0} letoma"
        }
      },
      "year-short": {
        "-1": "lani",
        "0": "letos",
        "1": "naslednje leto",
        "future": {
          "few": "čez {0} leta",
          "one": "čez {0} leto",
          "other": "čez {0} let",
          "two": "čez {0} leti"
        },
        "past": {
          "few": "pred {0} leti",
          "one": "pred {0} letom",
          "other": "pred {0} leti",
          "two": "pred {0} letoma"
        }
      }
    },
    "locale": "sl"
  });
}